import BaseSortable from "sortablejs";

declare module "sortablejs" {
	interface Utils {
		index(el: Element, selector?: string): number;
	}
}

export interface Sortable {
	captureAnimationState(): void;
	animateAll(callback?: () => void): void;
}

export class Sortable extends BaseSortable { }